import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { SiaSelectBoxComponent, SiaTextBoxComponent } from '@sia/inputs';
import {
  SiaComponentConfigPerspectives,
  SiaComponentConfigService,
  SiaI18nService,
  notify,
} from '@sia/shared';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ` <div class="sia-heading" mat-dialog-title>
      <span
        class="material-symbols-outlined sia-dialog-close-button"
        (click)="onNoClick()"
      >
        close
      </span>
      Modifica prospettiva
    </div>

    <div mat-dialog-content>
      <sia-text-box
        [(value)]="data.description"
        [disabled]="status == 'view' || status == 'delete'"
        label="Nome della prospettiva*"
        style="font-size: 18px"
      ></sia-text-box>

      <sia-select-box
        [fixedDataSource]="defaultModes"
        [(value)]="data.defaultMode"
        [selectBoxOptions]="{
          fixedDataSource: defaultModes,
          value: data.defaultMode,
        }"
        [disabled]="status == 'view' || status == 'delete'"
        style="font-size: 18px; padding-top: 8px;"
        label="Default"
      ></sia-select-box>
      @if (status == 'delete') {
        <div style="font-size: 18px; color: var(--mat-sys-error)">
          Sicuro di voler eliminare la prospettiva {{ data.description }} ?
        </div>
      }
    </div>
    <div mat-dialog-actions class="u-justify-content--center">
      <!-- VIEW -->
      @if (status == 'view') {
        <button mat-raised-button color="warn" (click)="onDeleteClick()">
          ELIMINA
        </button>
      }
      @if (status == 'view') {
        <button mat-raised-button (click)="onEdit()" color="primary">
          MODIFICA
        </button>
      }
      <!-- edit -->
      @if (status == 'edit') {
        <button
          mat-raised-button
          (click)="restoreOldPerspective()"
          color="warn"
        >
          ANNULLA
        </button>
      }
      @if (status == 'edit') {
        <button mat-raised-button (click)="onSaveClick()" color="primary">
          SALVA
        </button>
      }
      <!-- delete -->
      @if (status == 'delete') {
        <button mat-raised-button (click)="onNoDeleteClick()" color="warn">
          NO
        </button>
      }
      @if (status == 'delete') {
        <button mat-raised-button (click)="onYesDeleteClick()" color="primary">
          SI
        </button>
      }
    </div>`,
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    SiaTextBoxComponent,
    SiaSelectBoxComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class EditPerspectiveDialogComponent {
  private componentConfigService = inject(SiaComponentConfigService);
  dialogRef =
    inject<MatDialogRef<EditPerspectiveDialogComponent>>(MatDialogRef);
  private i18nService = inject(SiaI18nService);
  data = inject<SiaComponentConfigPerspectives>(MAT_DIALOG_DATA);

  status: string = 'view';
  oldperspective: SiaComponentConfigPerspectives | undefined;
  defaultModes: { id: string | null; description: string }[] = [
    { id: 'O', description: 'Altro' },
    { id: 'A', description: 'Tutti' },
    { id: 'M', description: 'Mobile' },
    { id: 'D', description: 'Desktop' },
  ];

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close(this.data);
  }
  onNoDeleteClick() {
    this.status = 'view';
  }

  onYesDeleteClick() {
    if (!this.data.id) {
      return;
    }
    this.componentConfigService
      .deletePerspective(this.data.id)
      .then((res: boolean) => {
        if (res) {
          notify('Prospettiva eliminata con successo', 2000, 'success');
          this.dialogRef.close(null);
        }
      });
  }
  onYesClick() {
    // this.data.result = true;
    this.dialogRef.close(this.data);
  }
  onEdit() {
    this.oldperspective = JSON.parse(JSON.stringify(this.data));
    this.status = 'edit';
  }
  onDeleteClick() {
    this.status = 'delete';
  }
  restoreOldPerspective() {
    if (this.oldperspective) {
      this.data = this.oldperspective;
    }
    this.status = 'view';
  }
  onSaveClick() {
    this.componentConfigService
      .updateComponentPerspectiveInfo(this.data)
      .then((data: SiaComponentConfigPerspectives) => {
        if (!data) return;
        notify('Prospettiva modificata con successo', 2000, 'success');
        this.data = data;
        this.status = 'view';
      });
  }
}
